import { render, staticRenderFns } from "./ResizeImageSize.vue?vue&type=template&id=35323500&scoped=true&"
import script from "./ResizeImageSize.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ResizeImageSize.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ResizeImageSize.vue?vue&type=style&index=0&id=35323500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35323500",
  null
  
)

export default component.exports